import { createFileRoute, redirect } from "@tanstack/react-router";

// English schema alias: Organization → /sobre
export const Route = createFileRoute("/organization")({
  beforeLoad: () => {
    throw redirect({ to: "/equipe", replace: true });
  },
  component: () => null,
});
